import {Component} from "./Component";
import ClipboardJS from "clipboard";
import {Toast} from "./Toast";

export class Clipboard extends Component {
    static name = "clipboard";

    get name() {
        return Clipboard.name;
    }

    constructor(el) {
        super(el);

        this.clipboard = new ClipboardJS(this.el);

        this.clipboard.on("success", () => {
            Toast.showToast("Der Code wurde in Deine Zwischenablage kopiert.", "success", 2000);
        });

        console.log("Clipboard", this);
    }
}
